<template>
	<div
		class=" pa-10 under-line"
		:class="program.title_class"
	>
		<div class="">
			<div class=" text-center position-relative">
				<button
					@click="toBack"
					class="hide-pc position-absolute"
					style="left: 0; top: 0px"
				><v-icon class="size-px-19-m">mdi mdi-chevron-left</v-icon></button>
				<h6 class="size-px-24-pc size-px-15-m text-center">{{ program.name }}</h6>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'Title'
		,props: ['program', 'cart_cnt', 'is_cart_view']
		,methods: {
			toBack: function(){
				if(this.program.from){
					this.$router.push({ name: this.program.from ,params: this.program.params})
				}else{
					this.$router.back()
				}
			}
		}
	}
</script>